/*
 * @Author: lzy
 * @Date: 2021-04-29 10:30:25
 * @LastEditTime: 2021-04-29 11:21:07
 * @LastEditors: lzy
 * @Description: 稿件档案头部按钮
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\docrecordBtns\docrecordBtns.js
 */
angular.module('iWoPreviewModule').directive('iwoDocrecordBtns', ['iWoService', 'editFusionEditorService', 'modalDialog',
    function(iWoService, editFusionEditorService, modalDialog) {
        return {
            scope: true,
            restrict: 'EA',
            templateUrl: './editingCenter/iWo/iWoPreview/directive/docrecordBtns/index.html',
            link: function($scope) {

                /**
                 * [batchCopyBuildDraft description]批量复制建新稿
                 * @return {[type]} [description]
                 */
                $scope.copyManuscript = function() {
                    if ($scope.list.DOCTYPEID === '11') {
                        modalDialog.alertType('稿件中包含串联单，串联单不允许复制新建稿', '', 'info', 'confirm', function() {});
                        return;
                    }
                    iWoService.copyBuildDraft([$scope.list], 'docrecordCopyBuildDraft', function() {
                        modalDialog.alertType('复制建新稿成功', '', 'success', false, function() {
                            // requestData();
                        });
                    });
                };

                /**
                 * [sendMessage description] 发送按钮
                 * @return  {[type]}  [return description]
                 */
                $scope.sendMessage = function () {
                    editFusionEditorService.sendmessage($scope);
                };
            }
        };
    }
]);
